var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99731 14.6616C11.6779 14.6616 14.6616 11.6779 14.6616 7.99731C14.6616 4.31672 11.6779 1.33301 7.99731 1.33301C4.31672 1.33301 1.33301 4.31672 1.33301 7.99731C1.33301 11.6779 4.31672 14.6616 7.99731 14.6616Z",
    stroke: "#733E0A",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99707 3.99854V7.99711L10.6628 9.32997",
    stroke: "#733E0A",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon28);
export default __webpack_public_path__ + "static/media/icon28.a0cb4240c8725ff0e2447d0125b6be60.svg";
export { ForwardRef as ReactComponent };